/* Copy to clipboard component: works with [data-copy-btn]
   Priority of source:
   1) data-copy-value on the button
   2) data-copy-target selector (scoped to closest parent or document)
   3) data-copy-default selector (searches in closest parent or document)
*/
import { notice } from './notices';

(function () {
	'use strict';

	function copyText(text) {
		if (!text) return Promise.reject(new Error('Empty text'));
		if (navigator.clipboard && navigator.clipboard.writeText) {
			return navigator.clipboard.writeText(text);
		}
		// Fallback for older browsers
		return new Promise(function (resolve, reject) {
			const textarea = document.createElement('textarea');
			textarea.value = text;
			textarea.setAttribute('readonly', '');
			textarea.style.position = 'fixed';
			textarea.style.opacity = '0';
			document.body.appendChild(textarea);
			textarea.select();
			try {
				const ok = document.execCommand('copy');
				document.body.removeChild(textarea);
				ok ? resolve() : reject(new Error('execCommand failed'));
			} catch (e) {
				document.body.removeChild(textarea);
				reject(e);
			}
		});
	}

	function resolveSource(btn) {
		// 1) explicit value
		const explicit = btn.getAttribute('data-copy-value');
		if (explicit) return explicit;
		// 2) selector target
		const selector = btn.getAttribute('data-copy-target');
		if (selector) {
			// Prefer closest scope
			const scope =
				btn.closest(btn.getAttribute('data-copy-scope') || '') || document;
			const target =
				(scope && scope.querySelector(selector)) ||
				document.querySelector(selector);
			if (target) {
				return (target.value || target.textContent || '').trim();
			}
		}
		// 3) default selector (if provided)
		const defaultSelector = btn.getAttribute('data-copy-default');
		if (defaultSelector) {
			const scope =
				btn.closest(btn.getAttribute('data-copy-scope') || '') || document;
			const target =
				(scope && scope.querySelector(defaultSelector)) ||
				document.querySelector(defaultSelector);
			if (target) {
				return (target.value || target.textContent || '').trim();
			}
		}
		return '';
	}

	function indicateCopied(btn) {
		btn.classList.add('is-copied');
		btn.setAttribute('aria-live', 'polite');
		btn.setAttribute('data-copied', 'true');
		window.setTimeout(function () {
			btn.classList.remove('is-copied');
			btn.removeAttribute('data-copied');
		}, 1200);
	}

	function onClick(e) {
		const btn = e.target.closest('[data-copy-btn]');
		if (!btn) return;
		e.preventDefault();
		const text = resolveSource(btn);
		copyText(text)
			.then(function () {
				indicateCopied(btn);
				// Показываем тост об успешном копировании
				notice('Скопировано в буфер обмена', 'success');
				const evt = new CustomEvent('copy:success', {
					bubbles: true,
					detail: { text },
				});
				btn.dispatchEvent(evt);
			})
			.catch(function (err) {
				const evt = new CustomEvent('copy:error', {
					bubbles: true,
					detail: { error: err && err.message ? err.message : String(err) },
				});
				btn.dispatchEvent(evt);
			});
	}

	function init() {
		document.addEventListener('click', onClick);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}
})();

